module.exports = __webpack_public_path__ + "assets/events_conflict_blue.cf394b55.svg";